var _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBannerForLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 848.99 888",
    style: {
      enableBackground: "new 0 0 848.99 888"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BG"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "shadow"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "elements"
  })), /*#__PURE__*/React.createElement("g", {
    id: "phone"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.56,
      fill: "#D2EBFF"
    },
    cx: 447.71,
    cy: 775.72,
    rx: 322.55,
    ry: 55.18
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#89CAF7"
    },
    d: "M418.46,742.92C305.34,719.1,219.14,635.4,169.17,500.87c-35.59-95.83-40.43-184.52-40.62-188.24 l-1.94-38.36l302.46-106.91l302.46,106.91l-1.94,38.36c-0.19,3.73-5.02,92.41-40.62,188.24 C639.01,635.4,552.81,719.1,439.69,742.92l-10.61,2.24L418.46,742.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M668.65,315.65l-239.57-84.68v0l0,0l0,0v0L189.5,315.65c0,0,16.22,320.86,239.57,367.9v0 c0,0,0,0,0,0c0,0,0,0,0,0v0C652.42,636.51,668.65,315.65,668.65,315.65z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#073A93"
    },
    points: "428.48,650.91 538.33,635.22 634.9,635.22 721.21,652.12 572.73,726.96  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M630.13,729.98c0,0-194.35-106.83-217.28-71.82c-33.13,50.57,17.5,76.05,197.97,124.33 L630.13,729.98z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1858B5"
    },
    d: "M683.7,783.37L683.7,783.37c4.81-11.62-0.71-24.95-12.33-29.76l-44.88-18.58l-17.43,42.09 l44.88,18.58C665.56,800.51,678.89,794.99,683.7,783.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#489BFF"
    },
    d: "M623.66,741.81l33.95,14.06c7.87,3.26,11.64,12.28,8.38,20.15c-3.26,7.87-12.32,11.63-20.19,8.37 l-33.95-14.06L623.66,741.81z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "#063272"
    },
    d: "M612,770.01l44.88,18.58c10.41,4.31,22.13,0.29,27.93-8.93 c-0.28,1.24-0.61,2.48-1.11,3.7c-4.81,11.62-18.14,17.14-29.76,12.33l-44.88-18.58L612,770.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M626.86,770.72l7.17-17.33c0.36-0.87,1.37-1.29,2.24-0.93l0,0c0.87,0.36,1.29,1.37,0.93,2.24 l-7.17,17.33c-0.36,0.87-1.37,1.29-2.24,0.93l0,0C626.92,772.6,626.5,771.59,626.86,770.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M637.42,775.09l7.17-17.33c0.36-0.87,1.37-1.29,2.24-0.93l0,0c0.87,0.36,1.29,1.37,0.93,2.24 l-7.17,17.33c-0.36,0.87-1.37,1.29-2.24,0.93l0,0C637.48,776.97,637.06,775.97,637.42,775.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M649.04,779.91l7.17-17.33c0.36-0.87,1.37-1.29,2.24-0.93l0,0c0.87,0.36,1.29,1.37,0.93,2.24 l-7.17,17.33c-0.36,0.87-1.37,1.29-2.24,0.93l0,0C649.1,781.79,648.68,780.78,649.04,779.91z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#489BFF"
    },
    d: "M700.54,585.6c-2.99-10.27-17.86-27.65-31.08-63.31c-13.75-37.07-72.33-41.06-72.33-41.06 l-22.74,12.17l-22.74-12.17c0,0-58.58,3.99-72.33,41.06c-13.22,35.65-28.1,53.04-31.08,63.31 c-2.99,10.27,13.15,76.71,59.48,86.12h64.91h3.53h64.91C687.39,662.31,703.53,595.87,700.54,585.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_30_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F49290"
    },
    d: "M599.66,481.47v18.22c0,0-4.21,20.35-24.03,23.74c-20.66-4.62-23.86-23.74-23.86-23.74v-18.22 H599.66z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    style: {
      fill: "#073A93"
    },
    d: "M530.17,445.68c0,0-6.78-42.59,9.42-47.76c4.41-1.41,1.19-15.47,25.85-15.65 c33.67-0.24,60.2-4.76,55.78,64L530.17,445.68z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB5B1"
    },
    d: "M551.52,450.38c0-6.42-5.21-11.63-11.63-11.63c-6.43,0-11.63,5.21-11.63,11.63 c0,6.43,5.21,11.63,11.63,11.63C546.31,462.01,551.52,456.81,551.52,450.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB5B1"
    },
    d: "M622.38,450.38c0-6.42-5.21-11.63-11.63-11.63c-6.43,0-11.63,5.21-11.63,11.63 c0,6.43,5.21,11.63,11.63,11.63C617.17,462.01,622.38,456.81,622.38,450.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB5B1"
    },
    d: "M614.41,430.67l-0.06-0.02v-0.01c-0.01,0-0.02,0-0.02,0c-0.47-0.15-9.75-3.24-11.53-15.44 l-5.09,1.43c-14.09,3.92-29.08,3.78-43.08-0.41l-4.06-1.02c-1.77,12.19-11.51,15.28-12.04,15.44c-0.01,0-0.1,0-0.1,0 l-0.32,18.85c0,10.97,4.63,24.3,12.05,34.56c6.03,8.35,15.79,13.18,26.09,13.18s20.06-4.83,26.09-13.18 c7.41-10.26,12.04-23.59,12.04-34.56l-0.02-18.77L614.41,430.67z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M646.33,586.73H504.79c-1.58,0-2.87,1.28-2.87,2.87v92.45c0,1.58,1.28,2.87,2.87,2.87h141.54 c1.58,0,2.87-1.28,2.87-2.87V589.6C649.2,588.02,647.91,586.73,646.33,586.73z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#89CAF7"
    },
    cx: 575.11,
    cy: 634.82,
    r: 15.29
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M514.79,729.98c0,0,194.35-106.83,217.28-71.82c33.13,50.57-17.5,76.05-197.97,124.33 L514.79,729.98z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1858B5"
    },
    d: "M461.22,783.37L461.22,783.37c-4.81-11.62,0.71-24.95,12.33-29.76l44.88-18.58l17.43,42.09 l-44.88,18.58C479.36,800.51,466.03,794.99,461.22,783.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#489BFF"
    },
    d: "M533.07,770.33l-33.95,14.06c-7.87,3.26-16.93-0.5-20.19-8.37c-3.26-7.87,0.51-16.89,8.38-20.15 l33.95-14.06L533.07,770.33z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.45,
      fill: "#063272"
    },
    d: "M532.92,770.01l-44.88,18.58c-10.41,4.31-22.13,0.29-27.93-8.93 c0.28,1.24,0.61,2.48,1.11,3.7c4.81,11.62,18.14,17.14,29.76,12.33l44.88-18.58L532.92,770.01z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M518.06,770.72l-7.17-17.33c-0.36-0.87-1.37-1.29-2.24-0.93l0,0c-0.87,0.36-1.29,1.37-0.93,2.24 l7.17,17.33c0.36,0.87,1.37,1.29,2.24,0.93l0,0C518.01,772.6,518.42,771.59,518.06,770.72z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M507.5,775.09l-7.17-17.33c-0.36-0.87-1.37-1.29-2.24-0.93l0,0c-0.87,0.36-1.29,1.37-0.93,2.24 l7.17,17.33c0.36,0.87,1.37,1.29,2.24,0.93l0,0C507.44,776.97,507.86,775.97,507.5,775.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M495.88,779.91l-7.17-17.33c-0.36-0.87-1.37-1.29-2.24-0.93l0,0c-0.87,0.36-1.29,1.37-0.93,2.24 l7.17,17.33c0.36,0.87,1.37,1.29,2.24,0.93l0,0C495.82,781.79,496.24,780.78,495.88,779.91z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M218.25,652.27c0,0-51.48-82.2-35.55-94.11c15.93-11.91,31.56,36.48,39.71,28.72 c8.15-7.76-28.4-76.88-11.14-91.75c17.26-14.87,15.97,35.61,30.63,44.99c14.66,9.38-7.93-68.78,9.61-80.99 c17.54-12.21,25.99,26.67,25.99,26.67s19.45-77.4,45.6-62.22c26.16,15.17-40.1,93.1-24.54,90.43 c15.56-2.67,31.54-28.98,45.03-11.25s-74.88,62.85-60.71,61.68c14.17-1.16,39.27-18.73,43.63-3.07 c4.36,15.66-71.72,43.92-63.83,49.34c7.88,5.42,47.65-25.29,53.91-2.68C322.85,630.62,234.04,666.65,218.25,652.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M212,684.36c9.6-16.01,17.61-33.4,23.81-51.68c3.26-9.59,6.04-19.52,8.73-29.12 c1.23-4.37,2.45-8.74,3.73-13.1c14.2-48.62,34.24-95.52,59.58-139.39l1,0.58c-25.29,43.79-45.3,90.6-59.47,139.13 c-1.27,4.35-2.5,8.72-3.72,13.09c-2.7,9.62-5.48,19.56-8.75,29.18c-6.23,18.36-14.28,35.82-23.92,51.9L212,684.36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M268.17,532.27c-0.1-0.07-0.18-0.17-0.22-0.3c-5.79-17.69-9.71-36.04-11.64-54.55 c-0.03-0.32,0.2-0.6,0.52-0.64c0.32-0.03,0.6,0.2,0.64,0.52c1.92,18.43,5.82,36.7,11.59,54.31c0.1,0.3-0.07,0.63-0.37,0.73 C268.5,532.4,268.31,532.37,268.17,532.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M260.93,553.62c-0.05-0.04-0.1-0.08-0.14-0.14c-0.19-0.26-0.13-0.62,0.13-0.81 c15.96-11.66,32.46-23.71,50.16-33.35c3.25-1.77,6.73-3.57,10.54-4.49c0.31-0.07,0.63,0.12,0.7,0.43 c0.08,0.31-0.12,0.62-0.43,0.7c-3.67,0.89-7.08,2.65-10.25,4.38c-17.62,9.6-34.1,21.63-50.03,33.27 C261.4,553.76,261.13,553.75,260.93,553.62z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M249.4,588.65c-0.06-0.04-0.11-0.09-0.15-0.16c-6.73-10.13-15.25-23.64-21.38-38.3 c-4.18-9.99-7.29-20.55-10.3-30.76c-0.09-0.31,0.08-0.63,0.39-0.72c0.31-0.09,0.63,0.08,0.72,0.39 c3,10.18,6.1,20.7,10.25,30.64c6.1,14.57,14.57,28.02,21.28,38.1c0.18,0.27,0.1,0.63-0.16,0.8 C249.85,588.79,249.59,588.78,249.4,588.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M249.23,589.17c-0.21-0.15-0.31-0.42-0.22-0.67c0.11-0.3,0.44-0.46,0.74-0.35 c1.63,0.59,3.47,0.37,5.2,0.03c4.7-0.9,9.3-2.61,13.75-4.26c0.83-0.31,1.66-0.62,2.49-0.92c13.15-4.8,26.88-8.47,40.16-12.01 c0.31-0.08,0.63,0.1,0.71,0.41c0.08,0.31-0.1,0.63-0.41,0.71c-13.25,3.54-26.96,7.19-40.06,11.98 c-0.83,0.3-1.66,0.61-2.48,0.92c-4.49,1.67-9.14,3.4-13.94,4.32c-1.81,0.35-3.91,0.61-5.81-0.08 C249.32,589.22,249.27,589.2,249.23,589.17z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M235.14,635.39c-15.39-10.58-33.02-39.09-43.45-60.3c-0.14-0.29-0.02-0.63,0.26-0.78 c0.29-0.14,0.63-0.02,0.78,0.26c10.37,21.07,27.86,49.4,43.07,59.85c0.26,0.18,0.33,0.54,0.15,0.81 C235.76,635.5,235.4,635.57,235.14,635.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M236.13,635.83c-0.14-0.09-0.27-0.2-0.4-0.3c-0.25-0.2-0.28-0.57-0.08-0.82 c0.2-0.25,0.59-0.28,0.81-0.08c2.18,1.76,5.44,1.21,8.65,0.33l56.16-15.38c0.31-0.08,0.63,0.1,0.71,0.41 c0.08,0.31-0.1,0.63-0.41,0.71l-56.16,15.38C242.09,636.99,238.67,637.58,236.13,635.83z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#489BFF"
    },
    d: "M211.41,650.76c0,0-89.12-38.61-82.73-57.48c6.39-18.87,46.74,12.19,49.06,1.16 c2.32-11.03-67.06-47.32-61.25-69.38c5.81-22.06,33.38,20.32,50.8,19.74c17.42-0.58-45.57-52.25-38.03-72.28 c7.55-20.03,36.58,7.26,36.58,7.26s-27.87-74.89,2.32-77.22c30.19-2.32,19.74,99.57,31.06,88.54 c11.32-11.03,9.58-41.8,30.77-34.83c21.19,6.97-26.13,94.34-15.1,85.34c11.03-9,21.77-37.74,34.25-27.29 c12.48,10.45-34.25,76.93-24.67,76.93c9.58,0,24.96-47.9,42.96-32.8C285.44,573.55,232.6,653.67,211.41,650.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M224.47,680.79c-1.17-18.66-4.42-37.55-9.67-56.15c-2.76-9.76-6.09-19.53-9.32-28.98 c-1.47-4.3-2.94-8.61-4.36-12.92c-15.88-48.17-25.95-98.24-29.93-148.82l1.16-0.09c3.98,50.48,14.03,100.46,29.88,148.54 c1.42,4.31,2.89,8.61,4.36,12.91c3.23,9.46,6.57,19.25,9.34,29.04c5.27,18.68,8.54,37.66,9.72,56.4L224.47,680.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M184.51,523.42c-0.12,0-0.25-0.04-0.35-0.12c-14.81-11.31-28.46-24.23-40.55-38.4 c-0.21-0.24-0.18-0.61,0.07-0.82c0.24-0.21,0.61-0.18,0.82,0.07c12.04,14.11,25.62,26.98,40.37,38.23 c0.25,0.19,0.3,0.56,0.11,0.81C184.86,523.35,184.69,523.42,184.51,523.42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M190.66,545.15c-0.06,0-0.13-0.01-0.19-0.03c-0.3-0.11-0.46-0.44-0.36-0.74 c6.55-18.67,13.33-37.99,22.46-55.97c1.68-3.3,3.53-6.77,6.14-9.68c0.22-0.24,0.58-0.26,0.82-0.04 c0.24,0.21,0.26,0.58,0.04,0.82c-2.52,2.81-4.33,6.2-5.97,9.43c-9.1,17.92-15.86,37.19-22.4,55.83 C191.12,545,190.9,545.15,190.66,545.15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M201.02,580.59c-0.07,0-0.15-0.01-0.22-0.04c-11.3-4.54-25.99-10.85-39.37-19.47 c-9.12-5.87-17.68-12.82-25.95-19.53c-0.25-0.2-0.29-0.57-0.08-0.82c0.2-0.25,0.57-0.29,0.82-0.08 c8.25,6.7,16.78,13.62,25.84,19.46c13.3,8.56,27.92,14.85,39.18,19.36c0.3,0.12,0.44,0.46,0.32,0.76 C201.47,580.45,201.25,580.59,201.02,580.59z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M201.18,581.12c-0.26,0-0.49-0.17-0.56-0.43c-0.08-0.31,0.1-0.63,0.41-0.71 c1.69-0.44,3.07-1.66,4.31-2.92c3.37-3.41,6.19-7.43,8.93-11.32c0.51-0.73,1.02-1.45,1.53-2.17 c8.13-11.43,17.38-22.24,26.32-32.69c0.21-0.24,0.57-0.27,0.82-0.06c0.24,0.21,0.27,0.57,0.06,0.82 c-8.93,10.44-18.16,21.23-26.26,32.61c-0.51,0.72-1.02,1.44-1.53,2.17c-2.76,3.93-5.61,7.99-9.05,11.47 c-1.29,1.31-2.88,2.72-4.84,3.23C201.27,581.12,201.22,581.12,201.18,581.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M215.77,627.25c-18.7,0-49.43-13.52-70.06-25.1c-0.28-0.16-0.38-0.51-0.22-0.79 c0.16-0.28,0.51-0.38,0.79-0.22c20.51,11.51,51.02,24.95,69.5,24.95c0.32,0,0.58,0.26,0.58,0.58S216.09,627.25,215.77,627.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M216.84,627.05c-0.17,0-0.34-0.01-0.51-0.02c-0.32-0.03-0.56-0.31-0.53-0.63 c0.03-0.32,0.33-0.56,0.63-0.53c2.8,0.22,5.17-2.09,7.32-4.63l37.61-44.55c0.21-0.25,0.58-0.27,0.82-0.07 c0.25,0.21,0.28,0.57,0.07,0.82l-37.61,44.55C222.41,624.63,219.93,627.05,216.84,627.05z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M171.97,664.52l14.23,88.07c2.02,12.49,12.8,21.67,25.45,21.67h43.36 c12.65,0,23.43-9.18,25.45-21.67l14.23-88.07H171.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACCFE5"
    },
    d: "M294.69,664.51h-24.17h-98.55l1.97,12.2h94.61l-12.26,75.87c-2.02,12.49-12.8,21.67-25.45,21.67 h24.17c12.65,0,23.43-9.18,25.45-21.67l12.26-75.87l0,0L294.69,664.51z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D2EBFF"
    },
    d: "M296.06,639.18H170.6c-7.05,0-12.82,5.77-12.82,12.82l0,0c0,7.05,5.77,12.82,12.82,12.82h125.46 c7.05,0,12.82-5.77,12.82-12.82l0,0C308.88,644.95,303.11,639.18,296.06,639.18z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAA45"
    },
    d: "M784.51,271.93h-272.6c-1.66,0-3.02,1.36-3.02,3.02v80.03c0,1.66,1.36,3.02,3.02,3.02h272.6 c1.66,0,3.02-1.36,3.02-3.02v-80.03C787.53,273.29,786.17,271.93,784.51,271.93z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M573.36,345.07h-43.02c-0.69,0-1.26-0.56-1.26-1.26v-32.06c0-0.69,0.56-1.26,1.26-1.26h43.02 c0.69,0,1.26,0.56,1.26,1.26v32.06C574.61,344.51,574.05,345.07,573.36,345.07z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M567.6,306.58h-4.29v-6.8c0-6.32-5.14-11.46-11.46-11.46c-6.32,0-11.46,5.14-11.46,11.46v6.8 h-4.29v-6.8c0-8.68,7.07-15.75,15.75-15.75c8.68,0,15.75,7.07,15.75,15.75V306.58z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFAA45"
    },
    d: "M556.65,323.22c0-2.65-2.15-4.8-4.8-4.8s-4.8,2.15-4.8,4.8c0,1.79,0.99,3.33,2.43,4.16 l-1.66,9.46h8.06l-1.66-9.46C555.67,326.55,556.65,325.01,556.65,323.22z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#073A93"
    },
    cx: 625.06,
    cy: 317.54,
    r: 7.88
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#073A93"
    },
    cx: 655.13,
    cy: 317.54,
    r: 7.88
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M693.08,317.54c0,4.35-3.53,7.88-7.88,7.88s-7.88-3.53-7.88-7.88s3.53-7.88,7.88-7.88 S693.08,313.19,693.08,317.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M723.15,317.54c0,4.35-3.53,7.88-7.88,7.88c-4.35,0-7.88-3.53-7.88-7.88s3.53-7.88,7.88-7.88 C719.62,309.67,723.15,313.19,723.15,317.54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M753.22,317.54c0,4.35-3.53,7.88-7.88,7.88c-4.35,0-7.88-3.53-7.88-7.88s3.53-7.88,7.88-7.88 C749.7,309.67,753.22,313.19,753.22,317.54z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#489BFF"
    },
    d: "M373.16,158.55v104.89c0,7.37-6.06,13.43-13.43,13.43H168.04c-7.42,0-13.48-6.06-13.48-13.43 V158.55c0-7.37,6.06-13.43,13.48-13.43h191.69C367.1,145.12,373.16,151.18,373.16,158.55z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.56,
    y: 181.86,
    style: {
      fill: "#073A93"
    },
    width: 218.6,
    height: 29.67
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M356.22,228.76h-54.39c-2.73,0-4.94,2.21-4.94,4.94l0,0c0,2.73,2.21,4.94,4.94,4.94h54.39 c2.73,0,4.94-2.21,4.94-4.94l0,0C361.16,230.97,358.95,228.76,356.22,228.76z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073A93"
    },
    d: "M356.22,248.09H331.5c-2.73,0-4.94,2.21-4.94,4.94l0,0c0,2.73,2.21,4.94,4.94,4.94h24.72 c2.73,0,4.94-2.21,4.94-4.94l0,0C361.16,250.31,358.95,248.09,356.22,248.09z"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "shield"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "lady"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerForLogin);
export default __webpack_public_path__ + "static/media/BannerForLogin.59a4d9b2c986aa799d30e57399d06afe.svg";
export { ForwardRef as ReactComponent };